import React, { useState,useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Button,
  CircularProgress,
  Chip,
  IconButton,
} from "@mui/material";
import "./addqueues.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CloseIcon from "@mui/icons-material/Close";
import { axiosInstance } from "../../../services/axiosInstance";
import { endpoints } from "../../../services/endpoint";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const AddQueuesPage = ({
  onClose,
  onProfileAdded, // parent callback to refresh
  // hoursOfOperation = ["Business Hours", "After Hours"],
  // quickConnect = ["AgentQuickConnect", "SupportQueueConnect"],
  // OutboundCallerIdName = ["+18005551234", "+14155550123"],
 
}) => {
  // ✅ Basic queue details
  const [queueName, setQueueName] = useState("");
  const [description, setDescription] = useState("");
  const [hopName, setHopName] = useState("");
  const [callername, setCallerName] = useState("");
  const [callernumber, setcallerNumber] = useState("");
  const [flowname, setFlowName] = useState("");
  const [connectname, setConnectName] = useState("");
  const [checked, setChecked] = useState(false);
  const [valuenumber, setValuenumber] = useState("");
  const [showTags, setShowTags] = useState(false);

  
  const [tags, setTags] = useState([]);
  const [key, setKey] = useState("");
  const [tagValue, setTagValue] = useState("");
const [actionClicked, setActionClicked] = useState(null); 
  // ✅ Loading states
  const [saveLoading, setSaveLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
 const [hoursOfOperation, setHoursOfOperation] = useState([]);
  const [OutboundCallerIdName, setOutboundCallerIdName] = useState([]);
   const [quickConnect, setQuickConnect] = useState([]);
  const [errors, setErrors] = useState({});
 const HopStoredName = localStorage.setItem("hopName", hopName);
  const instanceAlias = localStorage.getItem("instanceName");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  
  const username = localStorage.getItem("username");
  const EncryptedInstanceId=localStorage.getItem("EncryptedId")

  const region = localStorage.getItem("Region");
  const instanceId = localStorage.getItem("InstanceId");
  const email = localStorage.getItem("Email");
  const handlehoplist = async () => {
    const payload = {
      InstanceAlias:instanceAlias,
      awsAccount: customerAWSAccountId,
      region,
      ID:EncryptedInstanceId,
      UserName:username,
      Email:email, 
    };
    try {
      const response = await axiosInstance.post(
        endpoints.addQueuehop.getAfterHours,
        payload
      );
      if (response.status === 200) {
        console.log("Data saved successfully:", response.data);
        const body = JSON.parse(response.data.body);
        const listedHours = body.ListedHoursOfOperation;

        console.log("Data fetched successfully:", listedHours);
        setHoursOfOperation(listedHours);
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error saving user data:", error);
      // alert("An error occurred while saving user data.");
    }
  };

  const handleQuickConnect = async () => {
    const payload = {
     instanceAlias:instanceAlias,
      awsAccount: customerAWSAccountId,
      region,
       ID:EncryptedInstanceId,
      UserName:username,
      Email:email, 
    };
    try {
      const response = await axiosInstance.post(
        endpoints.quickConnect.getQuickConnectName,
        payload
      );
      if (response.data.statusCode === 200) {
        const body = JSON.parse(response.data.body);
        setQuickConnect(body.QuickConnects);
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error(error);
    }
  };
   const handleOutboundCallerIdName = async () => {
  const payload = {
    awsAccount: customerAWSAccountId,
    region,
    ID: EncryptedInstanceId,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.outbound.CallerId,
      payload
    );

    if (response.data.statusCode === 200) {
      console.log("outboundcalleridname saved successfully:", response.data);

      const parsed = JSON.parse(response.data.body); // this is already an array of strings
      console.log("calleridname", parsed);

      setOutboundCallerIdName(parsed); // directly set the array
    } else {
      console.error("Unexpected response:", response);
    }
  } catch (error) {
    console.error("Error saving user data:", error);
  }
};

useEffect(() => {
    handlehoplist();
  }, []);
  useEffect(() => {
    handleQuickConnect();
  }, []);

  useEffect(() => {
    handleOutboundCallerIdName();
  }, []);

  const validateName = (value) => {
    if (!value.trim()) {
      setErrors((prev) => ({ ...prev, queueName: "Queue name is required" }));
    } else {
      setErrors((prev) => ({ ...prev, queueName: "" }));
    }
  };

  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
  };

  const handleInputChange = (e) => {
    setValuenumber(e.target.value);
  };

  const incrementValue = () => {
    setValuenumber((prev) => (prev ? parseInt(prev) + 1 : 1));
  };

  const decrementValue = () => {
    setValuenumber((prev) =>
      prev && parseInt(prev) > 0 ? parseInt(prev) - 1 : 0
    );
  };

  const toggleShowTags = () => setShowTags((prev) => !prev);

  const handleAddTag = () => {
    if (key && tagValue) {
      setTags((prev) => [...prev, { key, value: tagValue }]);
      setKey("");
      setTagValue("");
    }
  };

  const handleDeleteTag = (index) => {
    setTags((prev) => prev.filter((_, i) => i !== index));
  };

  const handleCancel = () => {
     setActionClicked("cancel");
    setCancelLoading(true);
    setTimeout(() => {
      setCancelLoading(false);
       setActionClicked(null);
      if (onClose) onClose();
    }, 500);
  };

  /** ✅ FETCH QUEUES LIST (after save) */
  /** ✅ FETCH QUEUES */
const fetchQueues = async () => {
  const body = {
    ID: EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    region: region,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.queuesDisplay.viewQueues,
      body
    );

    if (response.data.statusCode === 200) {
      const data = JSON.parse(response.data.body);

      if (data.queues && Array.isArray(data.queues.DescribedQueues)) {
        const updatedlist = data.queues.DescribedQueues.map((item) => {
          const quickConnectNames =
            item.QuickConnects && Array.isArray(item.QuickConnects)
              ? item.QuickConnects.map((qc) => qc.QuickConnectName).join(", ")
              : "No QuickConnects";

          const tags = item.Tags
            ? Object.entries(item.Tags)
                .map(([key, value]) => `${key}: ${value}`)
                .join(", ")
            : "No tags";

          return {
            name: item.Name,
            description: item.Description || "No description",
            HoursOfOperationName: item.HoursOfOperationName || "No hours set",
            QuickConnectName: quickConnectNames,
            maxContacts: item.MaxContacts || "-",
            status: item.Status || "UNKNOWN",
            tags,
            arn: item.QueueArn,
            timeZone: item.TimeZone || "No timezone",
            config: item.Config || {},
            lastModifiedTime: item.LastModifiedTime || "No modification time",
            outboundCallerIdName:
              item.OutboundCallerConfig?.OutboundCallerIdName || "-",
            outboundCallerIdNumber: item.OutboundCallerIdNumber || "-",
            outboundFlowName: item.OutboundFlowName || "-",
            quickConnectTypes: item.QuickConnects
              ? item.QuickConnects.map((qc) => qc.QuickConnectType)
              : ["No Quick Connects"],
          };
        });

        return updatedlist; // ✅ RETURN updated list
      } else {
        console.warn("No DescribedQueues found in response");
        return [];
      }
    } else {
      console.error("Failed to fetch queues:", response.data.message);
      return [];
    }
  } catch (error) {
    console.error("Error fetching queues:", error);
    return [];
  }
};

/** ✅ SAVE NEW QUEUE */
const handleSave = async () => {
  // ✅ basic validation
  if (!queueName.trim()) {
    setErrors((prev) => ({ ...prev, queueName: "Queue name is required" }));
    return;
  }
  if (!description.trim()) {
    setErrors((prev) => ({ ...prev, description: "Description is required" }));
    return;
  }
  if (!hopName) {
    setErrors((prev) => ({ ...prev, hopName: "Select hours of operation" }));
    return;
  }
setActionClicked("save");
  setSaveLoading(true);

  const instanceAlias = localStorage.getItem("instanceName");

  const payload = {
    action: "CreateQueueWithTags",
    QueueName: queueName,
    QueueDescription: description || null,
    SelectedHOPName: hopName || null,
    OutboundCallerIdName: callername || null,
    OutboundCallerIdNumber: callernumber || null,
    OutboundFlowName: flowname || null,
    MaxContacts: checked ? parseInt(valuenumber, 10) : null,
    QuickConnectName: connectname || null,

    // ✅ Tags as an object { key: value }
    Tags: tags.reduce((acc, t) => ({ ...acc, [t.key]: t.value }), {}),

    ID: EncryptedInstanceId,
    awsAccount: customerAWSAccountId,
    region: region,
    InstanceAlias: instanceAlias,
    UserName: username,
    Email: email,
  };

  try {
    const response = await axiosInstance.post(
      endpoints.addQueue.addqueues,
      payload
    );

    console.log("✅ Queue Created:", response.data);

    if (response.data?.statusCode === 200) {
      // ✅ Refresh queues after save
      const updatedlist = await fetchQueues();

      // ✅ Update parent
      if (onProfileAdded) onProfileAdded(updatedlist);

      // ✅ Close modal
      if (onClose) onClose();
    } else {
      alert("Failed to create queue. Please try again.");
    }
  } catch (error) {
    console.error("❌ Error creating queue:", error);
    alert("Something went wrong while creating queue!");
  } finally {
    setSaveLoading(false);
    setActionClicked(null);
  }
};

  return (
    <Container className="addqueue-content-container">
       <Box display="flex" flexDirection="column" alignItems="flex-start" mb={2} gap={1}>
      {/* Back Arrow in a circular button */}
      <IconButton
        onClick={onClose}
        size="medium"
        sx={{
          border: "1px solid #ccc",       // border color
          borderRadius: "50%",            // makes it circular
          padding: 1,                     // inner spacing
          bgcolor: "#f5f5f5",             // background color
          "&:hover": { bgcolor: "#e0e0e0" } // hover effect
        }}
      >
        <ArrowBackIcon />
      </IconButton>
    
      {/* Title */}
      <Typography variant="h4" className="phone-text">
        Add Queue
      </Typography>
    </Box>

      {/* Queue Details */}
      <div className="queue-form-section">
        <h3>Queue Details</h3>
        <div className="queue-form-fields">
          <TextField
            label="Name"
            required
           placeholder="Enter Name"
            value={queueName}
            onChange={(e) => setQueueName(e.target.value)}
            onBlur={() => validateName(queueName)}
            helperText={errors.queueName}
            error={!!errors.queueName}
           
          />

          <TextField
            label="Description"
           placeholder="Enter description"
            required
            value={description}
            onChange={(e) => setDescription(e.target.value)}
           
            error={!!errors.description}
            helperText={errors.description}
          />
    

        <div>
          <b className="boldheadingfont">Hours of operation</b>
          <Typography className="additional-text">
            Set the hours of operation and timezone for a queue.{" "}
            <a
              href="https://docs.aws.amazon.com/connect/latest/adminguide/set-hours-operation.html"
              target="_blank"
              rel="noreferrer"
              className="addqueue-learnmore"
            >
              Learn More
            </a>
          </Typography>
          <TextField
            label="Select hours of operation"
           placeholder="Select hours of operation"
            value={hopName}
             
            onChange={(e) => setHopName(e.target.value)}
            error={!!errors.hopName}
            helperText={errors.hopName}
            required
            select
         
          >
            {hoursOfOperation.map((profile, index) => (
              <MenuItem key={index} value={profile}>
                {profile}
              </MenuItem>
            ))}
          </TextField>
        </div>
      </div>
    </div>
      {/* Settings */}
      <br />
      <div className="setting-form-section">
        <h3>Settings</h3>
        <b className="boldheadingfont">Outbound caller configuration</b>
        <Typography className="additional-text">
          Set the default caller ID name that will display to customers.{" "}
          <a
            href="https://docs.aws.amazon.com/connect/latest/adminguide/queues-callerid.html"
            target="_blank"
            rel="noreferrer"
            className="addqueue-learnmore"
          >
            Learn More
          </a>
        </Typography>

        {/* Outbound Caller ID */}
        <Box className="form-row" mt={2}>
          <div className="form-group">
            <Box
                                   display="flex"
                                   gap={1}
                                   mt={2}
                                 >
            <TextField
              label="Default caller ID name"
             placeholder="Callback ID name"
              value={callername}
              onChange={(e) => setCallerName(e.target.value)}
             
            />
        
            <TextField
              label="Default caller Number"
             placeholder="Search for phonenumbers"
            fullWidth

              value={callernumber}
              onChange={(e) => setcallerNumber(e.target.value)}
              select
             
            >
              {OutboundCallerIdName.map((profile, index) => (
                <MenuItem key={index} value={profile}>
                  {profile}
                </MenuItem>
              ))}
            </TextField>
         

          
            <TextField
              label="Outbound caller flow"
            placeholder="Selct caller flow"
            fullWidth

              value={flowname}
              onChange={(e) => setFlowName(e.target.value)}
              select
           
            >
              <MenuItem value="Default outbound">Default outbound</MenuItem>
            </TextField>
          </Box>
          </div>
        </Box>

        {/* Quick Connects */}
        <br />
        <Typography className="headings">Quick connects</Typography>
        <Typography className="additional-text">
          Choose the quick connects that agents working this queue will see.{" "}
          <a
            href="https://docs.aws.amazon.com/connect/latest/adminguide/quick-connects.html"
            target="_blank"
            rel="noreferrer"
            className="addqueue-learnmore"
          >
            Learn More
          </a>
        </Typography>

        <Box mt={2}>
          <TextField
            label="Search for quick connects"
          sx={{ width: "300px" }}
            value={connectname}
            onChange={(e) => setConnectName(e.target.value)}
            select
            className="queue-form-field"
          >
            {quickConnect.map((profile, index) => (
              <MenuItem key={index} value={profile}>
                {profile}
              </MenuItem>
            ))}
          </TextField>
        </Box>

        {/* Max Contacts */}
        <br />
        <Typography className="headings">Maximum contacts in queue</Typography>
        <Typography className="additional-text">
          Set the maximum contacts allowed to be in the queue.{" "}
          <a
            href="https://docs.aws.amazon.com/connect/latest/adminguide/set-maximum-queue-limit.html"
            target="_blank"
            rel="noreferrer"
            className="addqueue-learnmore"
          >
            Learn More
          </a>
        </Typography>

        <Box className="queue-limit-container" mt={1}>
          <FormControlLabel
            control={
              <Checkbox
                className="checkstylingaddqueue"
                checked={checked}
                onChange={handleCheckboxChange}
              />
            }
            label="Set a limit across all channels"
            className="limit-checkbox"
          />

          {checked && (
            <Box className="number-input-box" mt={1}>
             <TextField
  label="Maximum contacts in queue"
  placeholder="Maximum contacts in queue"
  required={checked}
  value={valuenumber}
  onChange={handleInputChange}
  error={!!errors.valuenumber}
  helperText={errors.valuenumber}
  type="number"   // 👈 use built-in number input
  InputProps={{
    inputProps: { min: 0, max: 100 },
    classes: { input: "number-input" }, // custom styling
  }}
/>

            </Box>
          )}
        </Box>

        <Box className="addqueue-tags-container" mt={2}>
          <Box className="addqueue-tagboxstyling" onClick={toggleShowTags}>
            <Typography variant="h6"className="addqueue-advancedtext">
              Show advanced settings
          
            <IconButton>
              {showTags ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
                  </Typography>
          </Box>

          {showTags && (
            <Box>
              <Typography className="addqueue-tagheading">
                Tags (Optional)
              </Typography>
              <Typography className="paratext">
                Add resource tags to identify and organize.{" "}
                <a
                  href="https://docs.aws.amazon.com/connect/latest/adminguide/tagging.html"
                  target="_blank"
                  rel="noreferrer"
                  className="addqueue-learnmore"
                >
                  Learn More
                </a>
              </Typography>

              {/* Tag input */}
              <Box
                                    display="flex"
                                    gap={1}
                                    mt={2}
                                  >
                <TextField
                  label="Key"
                  placeholder="Key"
                  value={key}
                  onChange={(e) => setKey(e.target.value)}
                  className="addqueue-input-field"
                />
                <TextField
                  label="Value"
                  placeholder="Value"
                  value={tagValue}
                  onChange={(e) => setTagValue(e.target.value)}
                  className="addqueue-input-field"
                  disabled={!key}
                />
                <Button
                  variant="outlined"
                  className="addqueue-add-button"
                  onClick={handleAddTag}
                  disabled={!key || !tagValue}
                >
                  Add
                </Button>
              </Box>

              {/* Selected Tags */}
              {tags.length > 0 && (
                <Box className="addqueue-tags-display" mt={1}>
                  <Typography variant="subtitle1">Selected tags</Typography>
                  <Typography variant="body2">
                    You can add up to {50 - tags.length} more tags
                  </Typography>
                  <Box className="addqueue-tags-list">
                    {tags.map((tag, index) => (
                      <Chip
                        key={index}
                        label={`${tag.key}: ${tag.value}`}
                        onDelete={() => handleDeleteTag(index)}
                        className="addqueue-tag-chip"
                      />
                    ))}
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </div>

      {/* Action Buttons */}
      <br />
      <div className="buttons-addqueue">
        <Button
          onClick={handleCancel}
          // className="cancel-button-addqueue"
       

           disabled={actionClicked === "save" || cancelLoading}
               >
                 <span className="adduser-button-content">
                   {actionClicked === "cancel" ? (
                     <CircularProgress size={18} style={{ color: "red" }} />
                   ) : (
                     "Cancel"
                   )}
                           </span>
        </Button>

        <Button
          onClick={handleSave}
         
           variant="contained"
                       disabled={actionClicked === "cancel" || saveLoading}
               >
                 <span className="adduser-button-content">
                   {actionClicked === "save" ? (
                     <CircularProgress size={18} style={{ color: "white" }} />
                   ) : (
                     "Save"
                   )}
                           </span>
        </Button>
      </div>

      <br />
    </Container>
  );
};

export default AddQueuesPage;
